
import { Timeline } from 'antd';
import { useEffect, useState } from 'react';

const ExperienceTimeLine = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [timelineMode, setTimelineMode] = useState("");

    useEffect(() => {
        window.addEventListener("resize", () => setWidth(window.innerWidth));
        // console.log(width);
        // console.log("resize detected");

        if (width <= 768) setTimelineMode("");
        else setTimelineMode("alternate");

        return () => {
            window.removeEventListener("resize", () => setWidth(window.innerWidth));
        };
    }, [width]);

    return (
        <div className='dark:bg-cDarkBG2/20 bg-white/20 backdrop-blur-[5px] border border-white/10 sm:rounded-[32px] rounded-[26px] px-5 pt-5 w-full'>
            <Timeline
                style={{
                    backgroundColor: 'transparent',
                }}
            
                // style={{ width: '100%' }}
                // className='w-full'
                mode={timelineMode}
                items={[
                     {
                        children: <MainTitle
                            timeStamp='Nov, 2025 - Present'
                            title='Software Engineer'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Org:</span> <span>EASCA Solutions Ltd.</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'></span> <span>- Reactjs, Nextjs, Tailwind CSS, Nodejs, Erp</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'green',
                    },
                     {
                        children: <MainTitle
                            timeStamp='Feb, 2025 - October, 2025'
                            title='Software Engineer'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Org:</span> <span>FringeCore</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'></span> <span>- Reactjs, Tailwind CSS, ERP</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'blue',
                    },
                    {
                        children: <MainTitle
                            timeStamp='Feb, 2022 - Jan, 2025'
                            title='Junior Software Engineer'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Org:</span> <span>Genie Infotech</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'></span> <span>- Reactjs, PHP, Laravel, MySQL</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'blue',
                    },
                    {
                        children: <MainTitle
                            timeStamp='2019'
                            title='Online MySQL instructor'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Org:</span> <span>Gyanjam BD</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'blue',
                    },



                ]}
            />
        </div>
    )
}

export default ExperienceTimeLine



const MainTitle = ({ title = "", timeStamp = '', subTItle = '', description = "" }) => {
    return (
        <div>
            {timeStamp ? <div className='text-xs md:text-sm dark:text-cDarkText text-gray-400'>{timeStamp}</div> : null}
            <div className='font-semibold text-base dark:text-cDarkText2 text-gray-600'>{title}</div>
            {subTItle ? <div className='dark:text-cDarkText text-gray-400'>{subTItle}</div> : null}
            {description ? <div className='dark:text-cDarkText text-gray-400'>{description}</div> : null}
        </div>
    )
}